import React from 'react';
import {Grid} from '@mui/material';
import TextField from '@mui/material/TextField';
import DatabaseMetadataEstadoSelect from './DatabaseMetadataEstadoSelect';
import {SelectPlus} from 'lib.front';
import {Aplicacion} from '../../bussines/entities/Aplicacion';
import {
   DatabaseMetadataNroDiasMantenerDbsProps,
   DatabaseMetadataSelectAppProps,
   DatabaseMetadataSelectEstadoProps
} from './DatabaseMetadataTableComponentsProps';

const DatabaseMetadataTableToolbarActions: React.FC<DatabaseMetadataSelectAppProps &
   DatabaseMetadataSelectEstadoProps &
   DatabaseMetadataNroDiasMantenerDbsProps> = ({
   appSelected,
   onAppSelectedChange,
   estadosElegidos,
   onEstadosElegidosChange,
   nroDias,
   onNroDiasChange
}) => {
   return (
      <>
         <Grid item xs={4} alignContent="center">
            <SelectPlus
               //@ts-ignore
               name="multidbApp"
               label="Elija una aplicacion:"
               entidad="multiDbAppList"
               campos={['id', 'denominacion', 'descripcion']}
               value={appSelected}
               onChange={onAppSelectedChange}
               genId={(registro: Aplicacion) => {
                  return registro.id;
               }}
               genLabel={(registro: Aplicacion) => registro.denominacion}
               InputLabelProps={{shrink: true}}
               variant="outlined"
               margin="dense"
               isClearable
               placeholder="Multi DB Apps"
            />
         </Grid>
         <Grid item xs={4} alignContent="center">
            <DatabaseMetadataEstadoSelect
               estadosElegidos={estadosElegidos}
               onEstadosElegidosChange={onEstadosElegidosChange}
            />
         </Grid>
         <Grid item xs={4} alignContent="center">
            <TextField
               id="outlined-number"
               label="Dias Adicionales"
               type="number"
               InputLabelProps={{
                  shrink: true
               }}
               value={nroDias}
               onChange={e => {
                  const newValue = e.target.value;
                  let parsedValue;
                  try {
                     parsedValue = parseInt(newValue);
                  } catch (error) {
                     return;
                  }
                  if (parsedValue < 0) {
                     return;
                  }
                  onNroDiasChange(parsedValue);
               }}
               size="small"
            />
         </Grid>
      </>
   );
};

export default DatabaseMetadataTableToolbarActions;
